import React from 'react';

// Orijinal HTML'deki 'projects' bölümünün React component'i
function Projeler() {
  
  // --- GÜNCELLENDİ --- Yeni görsel adları ve 6 adet proje
  // Bu görseller 'public' klasörüne yüklenen a1.png'den a6.png'ye kadar olan dosyalardır.
  const projeler = [
    { title: "Yeni Sanayi Tesisi", text: "Manisa - 2024", image: "/a1.png" },
    { title: "Lüks Rezidans", text: "Akhisar - 2023", image: "/a2.png" },
    { title: "Merkezi İş Merkezi", text: "Manisa - 2023", image: "/a3.png" },
    { title: "Altyapı Çalışması", text: "İzmir Yolu - 2022", image: "/a4.png" },
    { title: "Villa Kompleksi", text: "Akhisar - 2022", image: "/a5.png" },
    { title: "Kent Projesi", text: "Merkez - 2021", image: "/a6.png" }, 
  ];
  
  return (
    // section'a ID veriyoruz ki Navbar'dan link verilebilsin
    <section className="section projects" id="projeler">
      <div className="container">
        <h2 className="section-title">Projelerimiz</h2>
        <div className="projects-grid">
          
          {projeler.map((proje, index) => (
              <div className="project-card" key={index}>
                {/* --- GÜNCELLEME --- PicSum yerine kendi görselimiz */}
                <img src={proje.image} alt={proje.title} />
                <div className="project-overlay">
                  <h3>{proje.title}</h3>
                  <p>{proje.text}</p>
                </div>
              </div>
          ))}

        </div>
      </div>
    </section>
  );
}

export default Projeler;